import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './card.css';

export default class Card extends TemplateElement {
    constructor() {
        super({ styles: [style], shadowRender: true });
    }

    template() {
        return html`
            <div
                data-surface="light"
                class="h-full p-24 box-border bg-white rounded border-2 border-solid border-primary-subtle3"
            >
                <slot></slot>
            </div>
        `;
    }
}

defineElement('mb-card', Card);
